'use client';

import { c as _c } from "react/compiler-runtime";
import { BpiLinkBanner } from '~/components/marketing/BpiLinkBanner';
import useJourneyData from '~/hooks/useJourneyData';
import styles from './JourneyBpiLinkBanner.module.css';
const JourneyBpiLinkBanner = () => {
  const $ = _c(1);
  const journey = useJourneyData();
  const isSbsTrip = journey.source?.creationSource === "STEP_BY_STEP";
  if (isSbsTrip) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles.wrapper}><BpiLinkBanner tracking={{
        name: "journey_page_see_more_trips",
        label: "See more trips: lower page"
      }} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export { JourneyBpiLinkBanner };